import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
  Textarea,
} from '@shared/ui';

interface ReconciliationEnqueueDialogProps {
  open: boolean;
  loading?: boolean;
  reason: string;
  onOpenChange: (open: boolean) => void;
  onReasonChange: (value: string) => void;
  onConfirm: () => void;
}

export function ReconciliationEnqueueDialog({
  open,
  loading = false,
  reason,
  onOpenChange,
  onReasonChange,
  onConfirm,
}: ReconciliationEnqueueDialogProps) {
  const { t } = useTranslation('cabinet');
  const valid = reason.trim().length >= 3;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-h-[calc(100dvh-2rem)] sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{t('reconciliation.enqueue.title')}</DialogTitle>
          <DialogDescription>{t('reconciliation.enqueue.description')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="reconciliation-enqueue-reason">{t('reconciliation.enqueue.reason')}</Label>
          <Textarea
            id="reconciliation-enqueue-reason"
            value={reason}
            rows={3}
            onChange={(event) => onReasonChange(event.target.value)}
          />
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" className="w-full sm:w-auto" onClick={() => onOpenChange(false)}>
            {t('withdrawals.actions.back')}
          </Button>
          <Button
            type="button"
            variant="default"
            className="page-action-button w-full sm:w-auto"
            loading={loading}
            disabled={!valid}
            onClick={onConfirm}
          >
            {t('reconciliation.enqueue.action')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
